<template>
  <div class="relative">
    <input
      class="w-full p-4 bg-white rounded-lg focus:outline-none"
      :class="inputFieldClass"
      type="text"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <span v-if="showIcon" class="absolute top-0 right-0 bottom-0 flex items-center justify-center w-12">
      <i :class="setIcon" class="icon-color"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Enter text...',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    setIcon: {
      type: String,
      default: 'el-icon-search',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'light',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputFieldClass(){
      if(this.disabled){
        return 'ns-disable';
      } else if(this.theme === 'gray') {
        return 'ns-input-field-gray'
      }else if(this.theme === 'dark') {
        return 'ns-input-field-dark'
      } else {
        return 'ns-input-field-light'
      }
    }
  }
};
</script>

<style scoped>
input::placeholder {
  color: #999999;
}
.icon-color{
  color: #333333;
}
.bottom-0{
  bottom: 15px;
}
.ns-input-field-gray{
  background: #F6F7F9;
}
</style>
